import MChatQrcode from "./index.vue";
export default MChatQrcode;

